export const MAX_TASK_NUMNER = 20;